@if (link()) {
  <a
    class="wrapper"
    [attr.rel]="rel()"
    [class.disabled]="disabled()"
    [queryParamsHandling]="'merge'"
    [routerLink]="link() | addLangPrefix | async"
    [target]="targetMethod()"
    (click)="onButtonClick.emit()"
  >
    <ng-container [ngTemplateOutlet]="buttonContent" />
  </a>
} @else {
  <a
    class="wrapper"
    [attr.rel]="rel()"
    [class.disabled]="disabled()"
    [nodaHref]="buttonLink()"
    [target]="targetMethod()"
  >
    <ng-container [ngTemplateOutlet]="buttonContent" />
  </a>
}

<ng-template #buttonContent>
  <button
    tuiButton
    type="button"
    [appearance]="appearance()"
    [disabled]="disabled()"
    [size]="isResizable() | condition: computedButtonSize() : btnSize()"
  >
    @if (icon()?.position | equal: 'left') {
      <assets-icon
        position="left"
        [icon]="icon().name"
      />
    }
    <span class="text">
      <noda-translate [key]="text()" />
    </span>
    @if (icon()?.position | equal: 'right') {
      <assets-icon
        position="right"
        [icon]="icon().name"
      />
    }
  </button>
  @if (sideIcon()) {
    <svg-icon
      [name]="sideIcon().name"
      [size]="sideIcon().size"
    />
  }
</ng-template>
